import { render, staticRenderFns } from "./DashboardManagement.vue?vue&type=template&id=46975037&"
import script from "./DashboardManagement.vue?vue&type=script&lang=js&"
export * from "./DashboardManagement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports